import React, { useState, useContext } from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Row, Col } from '@thd-olt-component-react/grid';
import { Overlay } from '@thd-olt-component-react/overlay';
import { useReviewPhotosDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import { Carousel } from '@thd-olt-component-react/carousel';
import { CustomerImageOverlay } from '@thd-olt-component-react/customer-image-overlay';
import { usePresentation } from '../../context/PresentationProvider';
import './CustomerImageCarousel.scss';
import * as analytics from '../../ratings-reviews-analytics';
import {dataModel} from "../ReviewDataModel";

export const CustomerImageCarousel = ({ itemId }) => {
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [imageIndex, setImageIndex] = useState(null);
  const [imageId, setImageId] = useState(null);
  const { useCondensedLayout } = usePresentation();
  const { channel } = useContext(ExperienceContext);
  const { data, error, loading } = useReviewPhotosDeprecated({ itemId, ssr: false });

  if ((error && !data) || !data || loading) {
    return null;
  }
  const { reviewPhotos } = data || {};
  const { Results } = reviewPhotos || {};
  if (!(Results || []).length) {
    return null;
  }
  const photos = Results.reduce((images, review) => {
    return images.concat(review.Photos);
  }, []);

  const carouselContainer = classNames( 'customer-images' ,{
    'customer-images-condensed': useCondensedLayout
  });

  const carouselImage = classNames({
    'customer-images__carousel-normal': !useCondensedLayout,
    'customer-images__carousel-small': useCondensedLayout
  });

  const carouselHeader = classNames({
    'customer-images__mobile-header': useCondensedLayout
  });

  const carousel = classNames({
    'customer-images__mobile-carousel': useCondensedLayout
  });

  const onOverlayInteraction = () => {
    analytics.track('event', {
      origin: 'ratings and reviews',
      location: 'media',
      value: 'gallery',
      eventType: 'click'
    });
  };

  const onCarouselClick = ({ index, id }) => {
    setImageIndex(index);
    setImageId(id);
    setOverlayOpen(true);
    analytics.track('event', {
      origin: 'ratings and reviews',
      location: 'media',
      value: 'gallery',
      eventType: 'click'
    });
  };

  return (
    <div className={carouselContainer}>
      <Row>
        <Col xs={12} className={carouselHeader}>
          <span className="customer-image-title">Customer Images</span>
        </Col>
        <div className="customer-image-carousel-container">
          <Col xs={12} className={carousel}  flatten>
            <Carousel
              itemClass={useCondensedLayout ? "fixed-item-mobile" : "fixed-item"}
              fixedItem
              multiItem={false}
              showDots={false}
              itemWidthPixelsDesktop={220}
              itemWidthPixelsMobile={160}
              onClickItem={(itemIndex) => setImageIndex(itemIndex)}
              selectedItem={imageIndex}
            >
            {
              photos.map((photo, photoIndex) => {
                let thumbNailImg;
                if (photo.Sizes) {
                  thumbNailImg = `url(${photo.Sizes.normal.Url})`;
                }
                return (
                  <div
                    key={photoIndex.toString()}
                    className={carouselImage}
                  >
                    <button
                      style={{
                        backgroundImage: (thumbNailImg)
                      }}
                      onClick={() => onCarouselClick({ index: photoIndex,  id: photo.Id })}
                    />
                  </div>
                );
              })
            }
            </Carousel>
          </Col>
        </div>
        <Overlay medium={!useCondensedLayout} open={overlayOpen} onClose={() => setOverlayOpen(false)}>
          {overlayOpen && imageId ? (
              <CustomerImageOverlay
                channel={channel}
                photos={reviewPhotos}
                selectedPhotoID={imageId}
                onClose={() => {
                  setOverlayOpen(false);
                  setImageId(null);
                }}
                loopPhotos={photos?.length > 1}
                onInteraction={onOverlayInteraction}
              />
            ) : null}
        </Overlay>
      </Row>
    </div>
  );
};

CustomerImageCarousel.displayName = 'CustomerImageCarousel';

CustomerImageCarousel.propTypes = {
  itemId: string.isRequired,
};

CustomerImageCarousel.dataModel = dataModel;
